<script setup lang="ts">
import type { Wishlist } from '@yescapa-dev/ysc-api-js/legacy'
import { YSC_API_WISHLIST_ERROR } from '~/utils/error/YscErrorClasses'

interface Props {
  idCamper: number
  wishlist: Wishlist
}

const props = defineProps<Props>()

const loading = ref(false)

const { withErrorManagerHandling } = useWithErrorManagerHandling()
const wishlistsStore = useWishlistsStore()

const wishListsContainingIdCamper = computed(() => {
  return wishlistsStore.all.filter(({ ad_set }) => ad_set.find(({ id }) => id === props.idCamper))
})

const isIdCamperInWishList = (targetSlug: string) => {
  return wishListsContainingIdCamper.value.findIndex(({ slug }) => slug === targetSlug) !== -1
}

const addToOrRemoveFrom = async (targetSlug: string) => {
  loading.value = true

  if (isIdCamperInWishList(targetSlug)) {
    await withErrorManagerHandling(
      () => wishlistsStore.removeFromWishlist({ slug: targetSlug, product_id: props.idCamper }),
      YSC_API_WISHLIST_ERROR,
      false,
    )
  }
  else {
    await withErrorManagerHandling(
      () => wishlistsStore.addToWishlist({ slug: targetSlug, product_id: props.idCamper }),
      YSC_API_WISHLIST_ERROR,
      false,
    )
  }

  loading.value = false
}
</script>

<template>
  <li class="flex items-center justify-between px-6 py-3 hover:bg-gray-200 relative">
    <span
      :class="{ 'text-gray-400': loading }"
      class="flex gap-2 items-center"
    >
      {{ wishlist.name }} ({{ wishlist.ad_set.length }})
      <YscLoader
        v-if="loading"
        class="w-4 h-4"
      />
    </span>
    <button
      :disabled="loading"
      @click="addToOrRemoveFrom(wishlist.slug)"
    >
      <span
        class="absolute inset-0"
        aria-hidden="true"
      />
      <YscIconsHeart
        class="h-6 w-6 fill-current stroke-current"
        :class="[isIdCamperInWishList(wishlist.slug) ? 'text-pink-500' : 'text-gray-300']"
      />
    </button>
  </li>
</template>
